module.exports = __webpack_public_path__ + "static/media/Loneliness.f3480c9b.mp3";